import { HttpClient } from './types';

let _httpClient: HttpClient | null = null;

export const init = (client: HttpClient) => {
  _httpClient = client;
};

export const httpClient = () => {
  if (!_httpClient) throw new Error('Client not init');
  return _httpClient;
};
